module.exports = __webpack_public_path__ + "media/assets/images/landing_mobile/step-1-a08118fd829ecd505a667c9d4f80cf82.png";